// extracted by mini-css-extract-plugin
module.exports = {"list":"RadioGroup_list__3gD7i","item":"RadioGroup_item__1EtLk"};